export class CustomeTripQuestion {
  questionType: string;
  name: string = "";
  isRequired: boolean = false;
  answerType: string = "";
  question: string = "";
  prePostQuestionHashId: string = "";
  isActive: boolean = false;
  orderNo: number;
  isDefault: boolean;
  prePostEndDate: Date;
  isEditable: boolean;
  isDeletable: boolean;
  indexId: number;
  defaultLanguage: string = '';
  prePostQuestionparentHashId: string;
  isInherit: boolean;
  prepostQuestionsByLangList: PrepostQuestionsByLang[] = [];
  originalParentQuestionhashId:string;
}

export class PrepostQuestionsByLang {
  languageCode: string;
  language: string;
  questionText: string;
  isDeleted: boolean;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/pre-post-trip-question/models/custom-question.model.ts